import { render, staticRenderFns } from "./WidgetEmpty.vue?vue&type=template&id=7553f126&scoped=true&"
import script from "./WidgetEmpty.vue?vue&type=script&lang=js&"
export * from "./WidgetEmpty.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEmpty.vue?vue&type=style&index=0&id=7553f126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7553f126",
  null
  
)

export default component.exports